import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExcelIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13.059,
	height: 12.638,
	viewBox: "0 0 13.059 12.638",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "excel-icon",
		d: "M218.106,240v2.949H216v7.583h2.106v2.106h10.953V240Zm0,5.055h1.116l.569.843.569-.843h1.116l-1.116,1.685,1.116,1.685H220.36l-.569-.843-.569.843h-1.116l1.116-1.685Zm10.11,6.74h-9.268v-1.264h4.634V248h3.37v-.842h-3.37v-.843h3.37v-.842h-3.37v-.842h3.37v-.842h-3.37v-.843h-4.634v-2.106h9.268Z",
		transform: "translate(-216 -240)"
	})
});
export default SvgExcelIcon;
